enum PERMISSION_ACCESS
{
    READ_ONLY = 'READ_ONLY',
    FULL_ACCESS = 'FULL_ACCESS',
    ACCESS = 'ACCESS',
    READ = 'READ',
    WRITE = 'WRITE',
    DELETE = 'DELETE'
}

/**
 * @desc Permission module / system names (match `module.name` in DB).
 */
enum PERMISSION_MODULE
{
    DASHBOARD = 'Dashboard',
    USER = 'User',
    CITATION = 'Citation',
    VIN_SYSTEM = 'VIN System',
    CASE_QUEUE = 'Case Queue',
    PROBATION_SYSTEM = 'Probation System',
    CASE_ACTION = 'Case Action',
    DOCKET = 'Docket',
    DMV_AGENCY_SYSTEM = 'DMV Agency System',
    JURY_SYSTEM = 'Jury System',
    CASE_DETAIL = 'Case Detail',
    DOCUMENT = 'Document',
    FORM_TEMPLATES = 'Form Templates',
    CASE_WORKFLOW = 'Case Workflow',
    BOND_SYSTEM = 'Bond System',
    CASE_MOTION = 'Case Motion',
    MINUTE_ORDERS = 'Minute Orders',
    ADMINISTRATIVE_NOTES = 'Administrative Notes',
    JUDGE_NOTES = 'Judge Notes',
    PROSECUTOR_NOTES = 'Prosecutor Notes',
    OTHER_NOTES = 'Other Notes',
    SYSTEM_SETTINGS = 'System Settings'
}

export { PERMISSION_ACCESS, PERMISSION_MODULE };
